



















import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
import { mapState } from "vuex";
import { AppModule } from "../store/modules/app";

@Component({
  name: "FooterBar",
})
export default class FooterBar extends Vue {
  get year() {
    return dayjs().year();
  }

  get isFooterBarVisible() {
    return AppModule.isFooterBarVisible;
  }
}
